var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"poster-upload pc-poster-upload",style:({
    width: `${_vm.width}px`,
    height: `${_vm.height}px`,
  })},[(_vm.preview)?_c('div',{staticClass:"pic",style:(`background-image:url(${_vm.preview})`)}):_vm._e(),[_c('span',[_vm._v(_vm._s(_vm.text))]),_c('input',{ref:"preview",attrs:{"accept":"image/jpg, image/jpeg","name":"poster","type":"file","data-platform":_vm.platform,"data-width":_vm.width,"data-height":_vm.height,"data-size":_vm.size},on:{"change":_vm.handlePosterUpload}})]],2)
}
var staticRenderFns = []

export { render, staticRenderFns }